import Vue from 'vue'
import Vuex from 'vuex'
import {Message} from 'element-ui';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title: "OneCareer",
    VTVersion:"2.1.0",
    VTVersionCol:"2.1.0",
    VTVersionColName:"detailCol",
    VTVersionCol1:"2.1.0",
    VTVersionCol1Name:"detailteachercol",
    VTVersionCol2:"2.1.0",
    VTVersionCol2Name:"dropcouCol2",
    autoHeight: document.documentElement.clientHeight,
    dillDurationLimit1:55,
    dillDurationLimit2:90,
    dillDurationLimitValue:60,
    messageCount:0,
    count:0,
    msg:0,
    newmess: {
      message: "正在加载",
      iconClass: "el-icon-loading",
    },
    msgarr:[],
    col:[
      {
        label: "导师",
        prop: "tid.teacherName",
        width: "150",
        isTrue: true
      },
      {
        label: "时薪类型",
        prop: "cid.types",
        width: "110",
        isTrue: true
      },
      {
        label: "时薪",
        prop: "cid.classRate",
        width: "80",
        isTrue: true
      },
      {
        label: "美元额度",
        prop: "cid.salaryUSD",
        width: "110",
        isTrue: true
      },
      {
        label: "人民币额度",
        prop: "cid.salaryCNY",
        width: "120",
        isTrue: true
      },
      {
        label: "付款方式",
        prop: "tid.teacherPay",
        width: "110",
        isTrue: true
      },
      {
        label: "账号信息",
        prop: "tid.userInformation",
        width: "150",
        isTrue: true
      },
      {
        label: "账号姓名",
        prop: "tid.userName",
        width: "110",
        isTrue: true
      },
      {
        label: "计费时长",
        prop: "cid.billDuration",
        width: "110",
        isTrue: true
      },
      {
        label: "实际时长",
        prop: "cid.classActualDuration",
        width: "110",
        isTrue: true
      },
      {
        label: "学生号码",
        prop: "sid.studentPhone",
        width: "180",
        isTrue: true
      },
      {
        label: "班主任",
        prop: "sid.studentHeadmaster",
        width: "110",
        isTrue: true
      },
      {
        label: "班主任号码",
        prop: "sid.studentHeadmasterPhone",
        width: "160",
        isTrue: true
      },
      {
        label: "课节名称",
        prop: "cid.className",
        width: "200",
        isTrue: true
      },
      {
        label: "预定开始(PEK)",
        prop: "cid.classStartName",
        width: "180",
        isTrue: true
      },
      {
        label: "预定结束(PEK)",
        prop: "cid.classEndName",
        width: "180",
        isTrue: true
      },

      {
        label: "实际进入(PEK)",
        prop: "cid.classFastln",
        width: "180",
        isTrue: true
      },
      {
        label: "实际离开(PEK)",
        prop: "cid.classLastOut",
        width: "180",
        isTrue: true
      },
      {
        label: "预定开始(DFW)",
        prop: "cid.classStartNameDFW",
        width: "180",
        isTrue: true
      },
      {
        label: "预定结束(DFW)",
        prop: "cid.classEndNameDFW",
        width: "180",
        isTrue: true
      },
      {
        label: "实际进入(DFW)",
        prop: "cid.classFastlnDFW",
        width: "180",
        isTrue: true
      },
      {
        label: "实际离开(DFW)",
        prop: "cid.classLastOutDFW",
        width: "180",
        isTrue: true
      },
      {
        label: "学员课程",
        prop: "coid.courseName",
        width: "200",
        isTrue: true
      },
      {
        label: "课节类型",
        prop: "cid.isFree",
        width: "150",
        isTrue: true
      },
      {
        label: "课节性质",
        prop: "cid.isPublic",
        width: "150",
        isTrue: true
      },
      {
        label: "课程状态",
        prop: "serviceState.serviceStateName",
        width: "150",
        isTrue: true
      },
      {
        label: "学生邮箱",
        prop: "coid.email",
        width: "200",
        isTrue: true
      },
      {
        label: "课节ID",
        prop: "cid.id",
        width: "100",
        isTrue: true
      },
	  {
	    label: "课节状态",
	    prop: "cid.state",
	    width: "150",
	    isTrue: true
	  },
	  {
	    label: "课节评价",
	    prop: "cid.ifRate",
	    width: "150",
	    isTrue: true
	  },
    ],
    Col1:[{
      label: "导师",
      prop: "teacherName",
      width: "150",
      isTrue: true
    },
    {
      label: "时薪类型",
      prop: "types",
      width: "110",
      isTrue: true
    },
    {
      label: "时薪",
      prop: "price",
      width: "80",
      isTrue: true
    },
    {
      label: "计费时长",
      prop: "billDuration",
      width: "110",
      isTrue: true
    },
    {
      label: "实际时长",
      prop: "times",
      width: "110",
      isTrue: true
    },
    {
      label: "美元额度",
      prop: "payrateUSD",
      width: "110",
      isTrue: true
    },
    {
      label: "人民币额度",
      prop: "payrateCNY",
      width: "120",
      isTrue: true
    },
    {
      label: "付款方式",
      prop: "fukuanfangshi",
      width: "110",
      isTrue: true
    },
    {
      label: "账号信息",
      prop: "xinxi",
      width: "150",
      isTrue: true
    },
    {
      label: "账号姓名",
      prop: "name",
      width: "150",
      isTrue: true
    },
		{
		  label: "证件信息",
		  prop: "identity",
		  width: "150",
		  isTrue: true
		},
		{
		  label: "签约电话",
		  prop: "phone",
		  width: "150",
		  isTrue: true
		}
  ],
  Col2:[
    {
      label: "课程主键",
      prop: "id",
      width: "200",
      isTrue: false
    },
    {
      label: "学员课程",
      prop: "courseName",
      width: "200",
      isTrue: true
    },
    {
      label: "实际时长",
      prop: "times",
      width: "110",
      isTrue: true
    },
    {
      label: "计费时长",
      prop: "billDuration",
      width: "110",
      isTrue: true
    },
    {
      label: "美元额度",
      prop: "salaryUSD",
      width: "110",
      isTrue: true
    },
    {
      label: "人民币额度",
      prop: "salaryCNY",
      width: "120",
      isTrue: true
    }
    ,{
      label: "总课时",
      prop: "totalDuration",
      width: "120",
      isTrue: true
    }
    ,{
      label: "剩余课时",
      prop: "leftDuration",
      width: "120",
      isTrue: true
    }
    ,
    {
      label: "班主任",
      prop: "studentHeadmaster",
      width: "150",
      isTrue: true
    },{
      label: "学生邮箱",
      prop: "email",
      width: "200",
      isTrue: true
    },{
      label: "课程状态",
      prop: "serviceStateName",
      width: "150",
      isTrue: true
    },{
      label: "合同开始时间",
      prop: "contractStartTime",
      width: "200",
      isTrue: true
    },{
      label: "合同结束时间",
      prop: "contractEndTime",
      width: "200",
      isTrue: true
    },{
      label: "合同剩余天数",
      prop: "contractDiffDate",
      width: "150",
      isTrue: true
    },{
      label: "平均月预算(CNY)",
      prop: "averageMonthlyBudget",
      width: "200",
      isTrue: true
    },{
      label: "平均月预算(USD)",
      prop: "averageMonthlyBudgetUSD",
      width: "200",
      isTrue: true
    },{
      label: "实际平均月消费(CNY)",
      prop: "actualAverageMonthlyCost",
      width: "200",
      isTrue: true
    },{
      label: "实际平均月消费(USD)",
      prop: "actualAverageMonthlyCostUSD",
      width: "200",
      isTrue: true
    },{
      label: "剩余预算(USD)",
      prop: "remainingbudgetUSD",
      width: "200",
      isTrue: true
    }
	,{
	  label: "剩余预算(CNY)",
	  prop: "remainingbudgetCNY",
	  width: "200",
	  isTrue: true
	},{
      label: "剩余预算%",
      prop: "remainingbudgetPercentages",
      width: "200",
      isTrue: true
    }	,{
	  label: "优评奖金额(USD)",
	  prop: "usdMoney",
	  width: "200",
	  isTrue: true
	}
	,{
	  label: "优评奖金额(CNY)",
	  prop: "cnyMoney",
	  width: "200",
	  isTrue: true
	},
	{
	  label: "ClassIn状态",
	  prop: "state",
	  width: "150",
	  isTrue: true
	},
	{
	  label: "优评评价",
	  prop: "ifRate",
	  width: "150",
	  isTrue: true
	},
	// {
	//   label: "分值",
	//   prop: "score",
	//   width: "150",
	//   isTrue: true
	// },
	{
	  label: "结课时间",
	  prop: "courseEndTime",
	  width: "150",
	  isTrue: true
	},
	{
	  label: "交付时间",
	  prop: "submissionTime",
	  width: "150",
	  isTrue: true
	},
  ],
  dropCol:[{
    label: "导师",
    prop: "tid.teacherName",
    width: "150",
    isTrue: true
  },
  {
    label: "时薪类型",
    prop: "cid.types",
    width: "110",
    isTrue: true
  },
  {
    label: "时薪",
    prop: "cid.classRate",
    width: "80",
    isTrue: true
  },
  {
    label: "美元额度",
    prop: "cid.salaryUSD",
    width: "110",
    isTrue: true
  },
  {
    label: "人民币额度",
    prop: "cid.salaryCNY",
    width: "120",
    isTrue: true
  },
  {
    label: "付款方式",
    prop: "tid.teacherPay",
    width: "110",
    isTrue: true
  },
  {
    label: "账号信息",
    prop: "tid.userInformation",
    width: "150",
    isTrue: true
  },
  {
    label: "账号姓名",
    prop: "tid.userName",
    width: "110",
    isTrue: true
  },
  {
    label: "计费时长",
    prop: "cid.billDuration",
    width: "110",
    isTrue: true
  },
  {
    label: "实际时长",
    prop: "cid.classActualDuration",
    width: "110",
    isTrue: true
  },
  {
    label: "学生号码",
    prop: "sid.studentPhone",
    width: "180",
    isTrue: true
  },
  {
    label: "班主任",
    prop: "sid.studentHeadmaster",
    width: "110",
    isTrue: true
  },
  {
    label: "班主任号码",
    prop: "sid.studentHeadmasterPhone",
    width: "160",
    isTrue: true
  },
  {
    label: "课节名称",
    prop: "cid.className",
    width: "200",
    isTrue: true
  },
  {
    label: "预定开始(PEK)",
    prop: "cid.classStartName",
    width: "180",
    isTrue: true
  },
  {
    label: "预定结束(PEK)",
    prop: "cid.classEndName",
    width: "180",
    isTrue: true
  },

  {
    label: "实际进入(PEK)",
    prop: "cid.classFastln",
    width: "180",
    isTrue: true
  },
  {
    label: "实际离开(PEK)",
    prop: "cid.classLastOut",
    width: "180",
    isTrue: true
  },
  {
    label: "预定开始(DFW)",
    prop: "cid.classStartNameDFW",
    width: "180",
    isTrue: true
  },
  {
    label: "预定结束(DFW)",
    prop: "cid.classEndNameDFW",
    width: "180",
    isTrue: true
  },
  {
    label: "实际进入(DFW)",
    prop: "cid.classFastlnDFW",
    width: "180",
    isTrue: true
  },
  {
    label: "实际离开(DFW)",
    prop: "cid.classLastOutDFW",
    width: "180",
    isTrue: true
  },
  {
    label: "学员课程",
    prop: "coid.courseName",
    width: "200",
    isTrue: true
  },
  {
    label: "课节类型",
    prop: "cid.isFree",
    width: "150",
    isTrue: true
  },
  {
    label: "课节性质",
    prop: "cid.isPublic",
    width: "150",
    isTrue: true
  },
  {
    label: "课程状态",
    prop: "serviceState.serviceStateName",
    width: "150",
    isTrue: true
  },
  {
    label: "学生邮箱",
    prop: "coid.email",
    width: "200",
    isTrue: true
  },
  {
    label: "课节ID",
    prop: "cid.id",
    width: "100",
    isTrue: true
  },
  {
    label: "课节状态",
    prop: "cid.state",
    width: "150",
    isTrue: true
  },
  {
    label: "课节评价",
    prop: "cid.ifRate",
    width: "150",
    isTrue: true
  },
  ],
  dropCol1:[{
    label: "导师",
    prop: "teacherName",
    width: "150",
    isTrue: true
  },
  {
    label: "时薪类型",
    prop: "types",
    width: "150",
    isTrue: true
  },
  {
    label: "时薪",
    prop: "price",
    width: "150",
    isTrue: true
  },
  {
    label: "计费时长",
    prop: "billDuration",
    width: "110",
    isTrue: true
  },
  {
    label: "实际时长",
    prop: "times",
    width: "150",
    isTrue: true
  },
  {
    label: "美元额度",
    prop: "payrateUSD",
    width: "150",
    isTrue: true
  },
  {
    label: "人民币额度",
    prop: "payrateCNY",
    width: "150",
    isTrue: true
  },
  {
    label: "付款方式",
    prop: "fukuanfangshi",
    width: "150",
    isTrue: true
  },
  {
    label: "账号信息",
    prop: "xinxi",
    width: "150",
    isTrue: true
  },
  {
    label: "账号姓名",
    prop: "name",
    width: "150",
    isTrue: true
  },
  	{
  	  label: "证件信息",
  	  prop: "identity",
  	  width: "150",
  	  isTrue: true
  	},
  	{
  	  label: "签约电话",
  	  prop: "phone",
  	  width: "150",
  	  isTrue: true
  	}
  ],
  dropCol2:[
    {
      label: "课程主键",
      prop: "id",
      width: "200",
      isTrue: false
    },
    {
      label: "学员课程",
      prop: "courseName",
      width: "200",
      isTrue: true
    },
    {
      label: "实际时长",
      prop: "times",
      width: "110",
      isTrue: true
    },
    {
      label: "计费时长",
      prop: "billDuration",
      width: "110",
      isTrue: true
    },
    {
      label: "美元额度",
      prop: "sumUSD",
      width: "110",
      isTrue: true
    },
    {
      label: "人民币额度",
      prop: "sumCNY",
      width: "120",
      isTrue: true
    }
    ,{
      label: "总课时",
      prop: "totalDuration",
      width: "120",
      isTrue: true
    }
    ,{
      label: "剩余课时",
      prop: "leftDuration",
      width: "120",
      isTrue: true
    }
    ,
    {
      label: "班主任",
      prop: "studentHeadmaster",
      width: "150",
      isTrue: true
    },{
      label: "学生邮箱",
      prop: "email",
      width: "200",
      isTrue: true
    },{
      label: "课程状态",
      prop: "serviceStateName",
      width: "150",
      isTrue: true
    },{
      label: "合同开始时间",
      prop: "contractStartTime",
      width: "200",
      isTrue: true
    },{
      label: "合同结束时间",
      prop: "contractEndTime",
      width: "200",
      isTrue: true
    },{
      label: "合同剩余天数",
      prop: "contractDiffDate",
      width: "150",
      isTrue: true
    },{
      label: "平均月预算(CNY)",
      prop: "averageMonthlyBudget",
      width: "200",
      isTrue: true
    },{
      label: "平均月预算(USD)",
      prop: "averageMonthlyBudgetUSD",
      width: "200",
      isTrue: true
    },{
      label: "实际平均月消费(CNY)",
      prop: "actualAverageMonthlyCost",
      width: "200",
      isTrue: true
    },{
      label: "实际平均月消费(USD)",
      prop: "actualAverageMonthlyCostUSD",
      width: "200",
      isTrue: true
    },{
      label: "剩余预算(USD)",
      prop: "remainingbudgetUSD",
      width: "200",
      isTrue: true
    }
	,{
	  label: "剩余预算(CNY)",
	  prop: "remainingbudgetCNY",
	  width: "200",
	  isTrue: true
	},{
      label: "剩余预算%",
      prop: "remainingbudgetPercentages",
      width: "200",
      isTrue: true
    }	,{
	  label: "优评奖金额(USD)",
	  prop: "usdMoney",
	  width: "200",
	  isTrue: true
	}
	,{
	  label: "优评奖金额(CNY)",
	  prop: "cnyMoney",
	  width: "200",
	  isTrue: true
	},
	{
	  label: "ClassIn状态",
	  prop: "state",
	  width: "150",
	  isTrue: true
	},
	{
	  label: "优评评价",
	  prop: "ifRate",
	  width: "150",
	  isTrue: true
	},
	// {
	//   label: "分值",
	//   prop: "score",
	//   width: "150",
	//   isTrue: true
	// },
	{
	  label: "结课时间",
	  prop: "courseEndTime",
	  width: "150",
	  isTrue: true
	},
	{
	  label: "交付时间",
	  prop: "submissionTime",
	  width: "150",
	  isTrue: true
	},
  ]
  },
  mutations: {
    methodsAutoHeight(state): void{
      window.onresize = function(){
        state.autoHeight = document.documentElement.clientHeight;
      }
    },
    //count = 1时 为调用接口开始   =0为结束      store.commit('loadingInformation',1)
    loadingInformation(state,count: number): void{
      if(isNaN(state.messageCount))state.messageCount=0;
    },
  },
  actions: {
  },
  modules: {
  }
})
